import { debug, george, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { CardWithIconAndText } from "components/common/CardWithIconAndText";
import { ChooseAddressResponsive } from "components/common/ChooseAddress";
import { InfoBox } from "components/common/InfoBox";
import { FormattedHTMLMessage } from "i18n/util";
import { useEffect, useState } from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import trackingStore from "stores/TrackingStore";
import { ICreditCardOfferDetails } from "types/offer";
import { ChooseAccountEmbedded } from "../common/ChooseAccount";
import { ShopCreditCardBusinessAppointmentCard } from "./components/ShopCreditCardBusinessAppointmentCard";
import { CreditCardBusinessStore } from "./CreditCardBusinessStore";
import { ShopCreditCardBusinessRoutes } from "./ShopCreditCardBusinessRoutes";
import { GeorgeTextFieldFormsy } from "components/common/GeorgeTextField";
import * as Formsy from "formsy-react";
import { APIClientStatusCodeError } from "network/NetworkStapler";

// Validation now done BE side - letting it here just in case
// function isValidAccount(description?: string): boolean {
//     if (!description) {
//         return false;
//     }

//     const validCharactersRegex = /^[A-Za-z0-9 &()./,'-]{1,24}$/;
//     return validCharactersRegex.test(description);
// }

type IProps = RouteComponentProps<{}> & {
    store: CreditCardBusinessStore
};

type FormsyForm = {
    submit: () => void;
}

export const ShopCreditCardBusinessPersonalData = observer(({ store }: IProps) => {
    const [accountValid, setAccountValid] = useState<boolean | undefined>(undefined);
    const [inputValue, setInputValue] = useState<string>(store.milesAndMoreCardNumber || "");
    const [submitAttempted, setSubmitAttempted] = useState<boolean>(false);
    const formRef = React.useRef<FormsyForm>(null);

    const isLoading = store.isLoading;
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    const selectedAccount = store.accountsStore.selectedAccount;
    const selectedAddress = store.contactsStore.selectedAddress;

    const showAddressSelection = store.accountsStore.selectedAccount !== undefined && !store.isLoadingAddresses;
    const showMonthlyBill = showAddressSelection && selectedAddress !== undefined;

    const showAppointmentCard = !isLoading
        && (
            !(store.accountsStore.accounts && store.accountsStore.accounts.length > 0)
            || (selectedAccount !== undefined && (store.contactsStore.addresses === undefined || store.contactsStore.addresses.length < 1))
            || accountValid === false
        );

    const handleGoToNextStep = async () => {
        debug.log("### account", store.accountsStore.selectedAccount);
        debug.log("### address", store.contactsStore.selectedAddress);

        await trackingStore.trackEvent({ eventName: "nextPage" });
        pushRoute(ShopCreditCardBusinessRoutes.CARD_INFO);
    };

    const buttonDisabled = isLoading ||
        selectedAccount === undefined ||
        selectedAddress === undefined;

    const addressInfo = store.offer
        ? ui.__("shop.personalData.address.message", { productName: store.productName })
        : ui.__("shop.personalData.address.message.generic");
    const accountInfo = store.offer
        ? ui.__("shop.accountSelection.message", { productName: store.productName })
        : ui.__("shop.accountSelection.message.generic");



    const monthlyBillInfo = store.productName ? <FormattedHTMLMessage id="shop.creditCardBusiness.monthlyBill.infoBox.message.postal" values={{ product: store.productName }} /> : <FormattedHTMLMessage id="shop.creditCardBusiness.monthlyBill.infoBox.message.postal.generic" />;

    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;


    useEffect(() => {
        store.accountsStore.selectedAccount = undefined;
        store.contactsStore.selectedAddressId = undefined;
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (store.accountsStore.selectedAccount === undefined) {
            return;
        }



        const checkIfCardNameIsValid = async () => {
            try {
                const response = await store.getIsCardNameValid(externalInterfaceStore.productId ?? "", store.accountsStore.selectedAccount?.id ?? "", externalInterfaceStore.conditionsGroupId ?? "");
                const isValid = response.isValid;
                if (isValid) {
                    setAccountValid(true);
                    store.loadAddressesByAccountId(store.accountsStore.selectedAccount?.id);
                } else {
                    debug.log(`### account description '${store.accountsStore.selectedAccount?.description}' is invalid`)
                    setAccountValid(false);
                }
            } catch (error) {
                if (error instanceof APIClientStatusCodeError) {
                    if (error.response?.errors && Array.isArray(error.response.errors)) {
                        const hasAccountCheckInvalid = error.response.errors.some(
                            (e: { error?: string }) => e?.error === "ACCOUNT_CHECK_INVALID"
                        );

                        if (hasAccountCheckInvalid) {
                            debug.log(`### ACCOUNT_CHECK_INVALID error for account '${store.accountsStore.selectedAccount?.description}'`);
                            setAccountValid(false);
                            return;
                        }
                    }
                }

                debug.log("### unexpected error in checkIfCardNameIsValid", error);
                pushRoute("/error");
            }
        }

        checkIfCardNameIsValid();

    }, [store.accountsStore.selectedAccount]);

    return (
        <george.BackgroundWithNavBar>
            <PageComponent>
                {showAppointmentCard ?
                    <george.Card style={{ marginBottom: theme.MARGIN_SMALL }}>
                        <ShopCreditCardBusinessAppointmentCard isMobile={isMobile} noValidAddress={selectedAccount !== undefined} />
                    </george.Card>
                    :
                    <george.Card style={{ marginBottom: theme.MARGIN_SMALL }}>
                        <pr.A11yPopupHider>
                            {/* Account Selection */}
                            <div style={{ padding: theme.MARGIN }}>
                                <george.SectionTitle style={{ marginTop: 0 }}>
                                    {ui.__("shop.accountSelection.title")}
                                </george.SectionTitle>
                                <george.SectionSubtitle>
                                    {accountInfo}
                                </george.SectionSubtitle>
                            </div>
                            <ChooseAccountEmbedded
                                store={store.accountsStore}
                            />
                        </pr.A11yPopupHider>

                        {/* Address Selection */}
                        {
                            showAddressSelection &&
                            <pr.A11yPopupHider>

                                <pr.LightSeparatorLine spacing={theme.MARGIN} />
                                <div style={{ padding: theme.MARGIN }}>
                                    <ChooseAddressResponsive
                                        contactsStore={store.contactsStore}
                                        description={addressInfo}
                                        noAddressMessage={ui.__("shop.personalData.noAddress.message")}
                                    />
                                </div>

                                {store.isMilesAndMoreCreditCard && (
                                    <>
                                        <pr.LightSeparatorLine spacing={theme.MARGIN} />
                                        <div style={{ padding: theme.MARGIN }}>
                                            <Formsy.Form
                                                ref={formRef}
                                                onValidSubmit={async () => {
                                                    store.milesAndMoreCardNumber = inputValue;
                                                    await handleGoToNextStep();
                                                }}
                                                onInvalidSubmit={() => {
                                                    setSubmitAttempted(true);
                                                }}
                                            >
                                                <george.ResponsiveFormElement label={<FormattedHTMLMessage id="shop.cardInfo.milesAndMore.serviceCardNumber.label" />}>
                                                    <GeorgeTextFieldFormsy
                                                        name="milesAndMoreCardNumber"
                                                        required
                                                        validations="isMilesAndMoreCardNumber"
                                                        validationErrors={{
                                                            isMilesAndMoreCardNumber: ui.__("shop.cardInfo.milesAndMore.serviceCardNumber.error"),
                                                            isDefaultRequiredValue: ui.__("shop.cardInfo.milesAndMore.serviceCardNumber.error")
                                                        }}
                                                        inputMode="numeric"
                                                        validateEmpty={true}
                                                        instantError={submitAttempted}
                                                        value={inputValue}
                                                        onChange={(value: string) => {
                                                            setInputValue(value);
                                                        }}
                                                    />
                                                </george.ResponsiveFormElement>
                                            </Formsy.Form>
                                            <pr.P_14_CONTENT style={{ marginTop: theme.MARGIN_LARGE }}>
                                                <FormattedHTMLMessage id="shop.cardInfo.milesAndMore.serviceCardNumber.description" />
                                            </pr.P_14_CONTENT>
                                        </div>
                                    </>
                                )}
                                <pr.LightSeparatorLine spacing={theme.MARGIN} />

                                <div style={{ padding: theme.MARGIN }}>
                                    <george.SectionTitle style={{ marginTop: 0 }}>
                                        {ui.__("common.cardFormFactor")}
                                    </george.SectionTitle>
                                    <pr.HFlex style={{ justifyContent: "space-evenly", flexWrap: "wrap" }}>
                                        <div style={{ width: 290, textAlign: "center", marginTop: theme.MARGIN }}>
                                            <CardWithIconAndText
                                                checked={
                                                    store.cardFormFactor === "physical" ||
                                                    (!!store.offerDetails && !(store.offerDetails as ICreditCardOfferDetails).virtualCardSupported)
                                                }
                                                onClick={async () => {
                                                    await trackingStore.trackEvent({ eventName: "cardTypePhysicalSet" });
                                                    store.cardFormFactor = "physical";
                                                }}
                                                aria-label={ui.__("a11y.physicalCard")}
                                                text={ui.__("shop.cardInfo.cardFormFactor.physical")}
                                                icon={(
                                                    <pr.IconBankCardXL
                                                        style={{
                                                            width: 48,
                                                            height: 48,
                                                            color: store.cardFormFactor === "physical" ? theme.customColors.georgeLightBlue : theme.customColors.georgeLightGrey
                                                        }}
                                                    />
                                                )}
                                            />
                                            <pr.P_14_CONTENT style={{ marginTop: theme.MARGIN_SMALL }}>{ui.__("shop.creditCardBusiness.cardType.physical.message")}</pr.P_14_CONTENT>
                                        </div>
                                        {store.offerDetails && (store.offerDetails as ICreditCardOfferDetails).virtualCardSupported && (
                                            <div style={{ width: 290, textAlign: "center", marginTop: theme.MARGIN }}>
                                                <CardWithIconAndText
                                                    checked={store.cardFormFactor === "virtual"}
                                                    onClick={async () => {
                                                        await trackingStore.trackEvent({ eventName: "cardTypeVirtualSet" });
                                                        store.cardFormFactor = "virtual";
                                                    }}
                                                    aria-label={ui.__("a11y.virtualCard")}
                                                    text={ui.__("shop.cardInfo.cardFormFactor.virtual")}
                                                    icon={(
                                                        <pr.IconPhoneXL
                                                            style={{
                                                                width: 48,
                                                                height: 48,
                                                                color: store.cardFormFactor === "virtual" ? theme.customColors.georgeLightBlue : theme.customColors.georgeLightGrey
                                                            }}
                                                        />
                                                    )}
                                                />
                                                <pr.P_14_CONTENT style={{ marginTop: theme.MARGIN_SMALL }}>{ui.__("shop.creditCardBusiness.cardType.virtual.message")}</pr.P_14_CONTENT>
                                            </div>
                                        )}
                                    </pr.HFlex>
                                </div>

                            </pr.A11yPopupHider>

                        }

                        {/* Monthly Bill */}
                        {showMonthlyBill &&

                            <pr.A11yPopupHider>
                                <>
                                    <pr.LightSeparatorLine spacing={theme.MARGIN} />
                                    <div style={{ padding: theme.MARGIN }}>
                                        <george.SectionTitle style={{ marginTop: 0 }}>
                                            {ui.__("shop.creditCardBusiness.monthlyBill.title")}
                                        </george.SectionTitle>
                                        <pr.HFlex style={{ justifyContent: "space-evenly", flexWrap: "wrap" }}>
                                            <div style={{ width: 290, textAlign: "center", marginTop: theme.MARGIN }}>
                                                <CardWithIconAndText
                                                    checked={store.monthlyBillType === "postal"}
                                                    onClick={async () => {
                                                        await trackingStore.trackEvent({ eventName: "monthlyBillPostalSet" });
                                                        store.monthlyBillType = "postal";
                                                    }}
                                                    aria-label={ui.__("a11y.postal")}
                                                    text={ui.__("shop.cardInfo.monthlyBill.postal")}
                                                    icon={(
                                                        <pr.IconMailXL
                                                            style={{
                                                                width: 48,
                                                                height: 48,
                                                                color: store.monthlyBillType === "postal" ? theme.customColors.georgeLightBlue : theme.customColors.georgeLightGrey
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </pr.HFlex>
                                        <InfoBox
                                            title={ui.__("shop.creditCardBusiness.monthlyBill.infoBox.title")}
                                            content={(
                                                <pr.P_16_CONTENT>
                                                    {monthlyBillInfo}
                                                </pr.P_16_CONTENT>)
                                            }
                                            style={{ width: "100%", margin: 0, marginTop: theme.MARGIN }}
                                        />
                                    </div>
                                </>

                            </pr.A11yPopupHider>
                        }

                        <pr.A11yPopupHider>
                            {!externalInterfaceStore.isGeorgeApp &&
                                <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            }
                            <george.ActionButton
                                messageId={store.isLoading ? undefined : "button.continue"}
                                disableButton={buttonDisabled}
                                isLoading={store.isLoading}
                                onClick={async () => {
                                    if (store.isMilesAndMoreCreditCard) {
                                        if (formRef.current) {
                                            formRef.current.submit();
                                        }
                                        return;
                                    }

                                    await handleGoToNextStep();
                                }}
                                {...george.getActionButtonWebVersionProps()}
                            />
                        </pr.A11yPopupHider>
                    </george.Card>
                }
            </PageComponent>
        </george.BackgroundWithNavBar >
    );

});


// WEBPACK FOOTER //
// ./src/components/shopCreditCardBusiness/ShopCreditCardBusinessPersonalData.tsx